export { default as SizerAdmin } from "./SizerAdmin.container"
export { 
  default as AdminReducer,
  ADMIN_KEY
} from "./SizerAdmin.module"